module.exports = __webpack_public_path__ + "img/draft_docs.41f628a0.svg";